import type { RouteRecordRaw } from 'vue-router'

// Me 模块子页（设置 / 客服）
export const meRoutes: RouteRecordRaw[] = [
  {
    path: '/me/pim',
    name: 'me-pim',
    component: () => import('@/pages/Me/PIM/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/me/help-center',
    name: 'me-help-center',
    component: () => import('@/pages/Me/HelpCenter/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/me/customer-service',
    name: 'me-customer-service',
    component: () => import('@/pages/Me/CustomerService/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/me/setting',
    name: 'me-setting',
    component: () => import('@/pages/Me/Setting/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/me/setting/about-ai-companion',
    name: 'me-setting-about-ai-companion',
    component: () => import('@/pages/Me/Setting/AboutAICompanion/index.vue'),
    meta: { backMode: 'allow' },
  },
]
